import { TokenListMetadata } from ".";

/**
 * This is a fallback metadata for tokens that are not in the token list.
 * It is used to display UNKNOWN token in the UI.
 * It should ONLY be used as a fallback for loans with missing metadata or failed migrations.
 */
export const FALLBACK_METADATA: TokenListMetadata = {
    mint: "11111111111111111111111111111111",
    name: "Unknown Token",
    symbol: "UNK",
    decimals: 9,
    assetType: 0,
    isPrincipal: false,
    isCollateral: false,
    imageUrl: "https://bridgesplit-app.s3.amazonaws.com/logo/logo_new_blue.png",
    tokenProgram: "",
    numLuts: undefined,
    tags: [],
    custodian: ""
};
